/* global modForm */
import { trackFormSubmissionFlow } from '../../helpers';
/**
 * Switch form loading state
 * @param {Bool} isLoading - true to switch on loading state, false to switch if off
 */
export function switchFormLoadingState(isLoading) {
	trackFormSubmissionFlow({ inSwitchFormLoadingState: true });
	if (isLoading) {
		if (modForm.opts.zipFormSelectorsToSync.length) {
			document.querySelectorAll(modForm.opts.zipFormSelectorsToSync).forEach(function(form) {
				form.classList.add(modForm.opts.formLoadingCls);
			});
		}
		modForm.opts.form.classList.add(modForm.opts.formLoadingCls);
		modForm.opts.isFormLoading = true;
	} else {
		if (modForm.opts.zipFormSelectorsToSync.length) {
			document.querySelectorAll(modForm.opts.zipFormSelectorsToSync).forEach(function(form) {
				form.classList.remove(modForm.opts.formLoadingCls);
			});
		}
		modForm.opts.form.classList.remove(modForm.opts.formLoadingCls);
		modForm.opts.isFormLoading = false;
	}
}
